import { render, staticRenderFns } from "./group-documents-header.vue?vue&type=template&id=b437e5ca&"
import script from "./group-documents-header.vue?vue&type=script&lang=js&"
export * from "./group-documents-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports